module.exports = __webpack_public_path__ + "img/70.d7afa8c7.jpg";